export const english = {
  translations: {
    'Select Your Invoice Language': 'Select Your Invoice Language',
    'Preliminary Invoice': 'Preliminary Invoice',
    Preliminaryinvoice: 'Preliminary Invoice',
    'Customer no': 'Customer no',
    'Invoice No': 'Invoice No',
    'Not created yet': 'Not created yet',
    'Your reference': 'Your reference',
    'Your VAT number': 'Your VAT number',
    'Our reference': 'Our reference',
    'Payment terms': 'Payment terms',
    Days: 'Days',
    'Due date': 'Due date',
    'Invoice date': 'Invoice date',
    'Article No.': 'Article No.',
    Name: 'Name',
    Quantity: 'Quantity',
    Unit: 'Unit',
    'Price per unit': 'Price per unit',
    Total: 'Total',
    'Fixed Price': 'Fixed Price',
    'Excluding VAT': 'Excluding VAT',
    'VAT %': 'VAT %',
    VAT: 'VAT',
    'Round-off': 'Round-off',
    Currency: 'Currency',
    'ROT / RUT': 'ROT / RUT',
    'To pay': 'To pay',
    'PLEASE NOTE THAT THIS IS A PRELIMINARY INVOICE': 'PLEASE NOTE THAT THIS IS A PRELIMINARY INVOICE',
    'Org. Number': 'Org. Number',
    'Vat Number': 'VAT Number',
    'Total working hours:': 'Total working hours:',
    'Invoice': 'Invoice',
    'Payment Per Hour': 'Payment Per Hour',
    'Payment Per Day': 'Payment Per Day',
    'Payment Per Week': 'Payment Per Week',
    'Payment Per Month': 'Payment Per Month',
    'Payment As Agreed': 'Payment As Agreed',
    "Amount inc. VAT": "Amount inc. VAT",
    "Something went wrong while saving invoice, this invoice has been cancelled. Please try again.": "Something went wrong while saving invoice, this invoice has been cancelled. Please try again.",
    "Amount after taxes": "Amount after taxes",
    "Please note: As of May 27, 2025, we are using a new Swedish bankgiro number, managed by PS Betalningsservice. All IBAN payments should be paid to Invozios account at Revolut.": "Please note: As of May 27, 2025, we are using a new Swedish bankgiro number, managed by PS Betalningsservice. All IBAN payments should be paid to Invozios account at Revolut.",
    "You have received an invoice from Invozio in collaboration with PS Betalningsservice, which manages the invoice's bankgiro, and TP Finance, which handles salary payments to the affiliated freelancer.": "You have received an invoice from Invozio in collaboration with PS Betalningsservice, which manages the invoice's bankgiro, and TP Finance, which handles salary payments to the affiliated freelancer.",
    "The freelancer's name is listed as the reference on the invoice. If you have any questions regarding the invoice, pricing, or the work performed, please contact the freelancer directly. They have also received a copy of the invoice.": "The freelancer's name is listed as the reference on the invoice. If you have any questions regarding the invoice, pricing, or the work performed, please contact the freelancer directly. They have also received a copy of the invoice.",
    "If you have any questions, feel free to contact us:": "If you have any questions, feel free to contact us:",
    "Your continued trust in Invozio inspires us to serve you better.": "Your continued trust in Invozio inspires us to serve you better.",
    "Here is your credit invoice from Invozio.": "Here is your credit invoice from Invozio.",
    "This invoice has been issued to adjust a previous charge and should be used as supporting documentation in your accounting.": "This invoice has been issued to adjust a previous charge and should be used as supporting documentation in your accounting.",
    "If you have any questions or concerns regarding this credit invoice, previous invoices, or anything else related to our services, you are always welcome to reach out to us.": "If you have any questions or concerns regarding this credit invoice, previous invoices, or anything else related to our services, you are always welcome to reach out to us.",
    "Please see the copy of the invoice, the invoice has been sent out as an E-invoice to your customer.": "Please see the copy of the invoice, the invoice has been sent out as an E-invoice to your customer.",
  }
};
